import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import candidateApi from "../../services/Api/candidateApi";

// Async thunk for adding a candidate
export const addCandidate = createAsyncThunk(
  "candidate/addCandidate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await candidateApi.addCandidate(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const addIndividual = createAsyncThunk(
  "candidate/addIndividual",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await candidateApi.addIndividualCandidate(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getPosition = createAsyncThunk(
  "candidate/getPosition",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateApi.getPosition();
      // console.log(response?.data?.data,"responseresponseresponse")
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const addPosition = createAsyncThunk(
  "candidate/addPosition",
  async (payloadData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.addPosition(payloadData);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const positionGetById = createAsyncThunk(
  "candidate/positionGetById",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateApi.positionGetById();
      return response?.data?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const getReport = createAsyncThunk(
  "candidate/getReport",
  async (id, { rejectWithValue }) => {
    try {
      const response = await candidateApi.getReport(id);
      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      console.log(errMsg, "Error caught in getReport");
      return rejectWithValue(errMsg);
    }
  }
);
export const sendNotification = createAsyncThunk(
  "candidate/sendNotification",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await candidateApi.sendNotification(payload);
      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      console.log(errMsg, "Error caught in getReport");
      return rejectWithValue(errMsg);
    }
  }
);

export const viewReport = createAsyncThunk(
  "candidate/viewReport",
  async (id, { rejectWithValue }) => {
    try {
      const response = await candidateApi.viewReport(id);
      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      console.log(errMsg, "Error caught in viewReport");
      return rejectWithValue(errMsg);
    }
  }
);

export const changePositionStatus = createAsyncThunk(
  "candidate/changePositionStatus",
  async (payloadData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.changePositonStatus(payloadData);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const fetchNewPosition = createAsyncThunk(
  "candidate/fetchNewPosition",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateApi.fetchNewPosition();
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getOpenPosition = createAsyncThunk(
  "candidate/getOpenPosition",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateApi.getOpenPosition();
      // console.log("response.data?.data", response.data?.data)
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const addCompanyRating = createAsyncThunk(
  "candidate/addCompanyRating",
  async (ratingPayload, { rejectWithValue }) => {
    try {
      const response = await candidateApi.addCompanyRating(ratingPayload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getDownloadExcelData =createAsyncThunk(
  "candidate/getDownloadExcelData",
  async(_,{rejectWithValue})=>{
    try{
      const response = await candidateApi.getExcelData();
      return response.data
    }catch(error){
      console.log("eeee",error)
      return rejectWithValue(error || "failed to load data.")
    }
  }
)


const candidateSlice = createSlice({
  name: "candidate",
  initialState: {
    loading: false,
    error: null,
    success: false,
    candidateData: null,
    positions: [],
    report: null,
    addedPosition: null,
    positionGetByIdList: null,
    positionStatus: null,
    fetchNewPositionData: [],
    getOpenPositionData: null,
    companyRating: null,
    excelData:[]
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.candidateData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCandidate.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addCandidate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.candidateData = action.payload;
      })
      .addCase(addCandidate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(addIndividual.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addIndividual.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.candidateData = action.payload;
      })
      .addCase(addIndividual.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getPosition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.positions = action.payload;
      })
      .addCase(getPosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReport.fulfilled, (state, action) => {
        state.loading = false;
        state.report = action.payload;
      })
      .addCase(getReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unknown error occurred";
      })
      .addCase(viewReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewReport.fulfilled, (state, action) => {
        state.loading = false;
        state.report = action.payload;
      })
      .addCase(viewReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unknown error occurred";
      })
      .addCase(addPosition.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.addedPosition = action.payload;
      })
      .addCase(addPosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(positionGetById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(positionGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.positionGetByIdList = action.payload;
      })
      .addCase(positionGetById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(changePositionStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(changePositionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.positionStatus = action.payload;
      })
      .addCase(changePositionStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(fetchNewPosition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchNewPositionData = action.payload;
      })
      .addCase(fetchNewPosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOpenPosition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOpenPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.getOpenPositionData = action.payload;
      })
      .addCase(getOpenPosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addCompanyRating.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addCompanyRating.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.companyRating = action.payload;
      })
      .addCase(addCompanyRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(sendNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.candidateData = action.payload;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getDownloadExcelData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getDownloadExcelData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.excelData = action.payload;
      })
      .addCase(getDownloadExcelData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetStatus } = candidateSlice.actions;

export default candidateSlice.reducer;
